/* eslint-disable max-len */
import { SvgProps } from './types'

export const AirplaneIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M40.4694 4.57285C40.4973 2.88024 39.1201 1.50299 37.4275 1.53094C35.8865 1.55489 34.4135 2.17764 33.3237 3.26746L26.7169 9.87425L9.27975 5.82634C8.14602 5.56287 6.96039 5.90219 6.13804 6.72455L3.41149 9.4511L20.0382 16.5529L13.172 24.1297L6.87257 23.1796C5.48734 22.9721 4.08614 23.4311 3.09612 24.4212L1.53125 25.986L11.6829 30.3134L16.0103 40.4651L17.5752 38.9002C18.5652 37.9102 19.0243 36.509 18.8167 35.1238L17.8666 28.8243L25.4794 21.9222L32.5452 38.5808L34.5293 36.5968C35.8147 35.3114 36.3416 33.4591 35.9344 31.6906L32.1261 15.2794L38.7328 8.67265C39.8227 7.58283 40.4454 6.10978 40.4694 4.56886V4.57285Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
